<template>
  <div class="mt-3" v-if="jubilees?.length">
    <h6 class="sidebar-section-title mb-2">
      <i class="fa-solid fa-award text-warning me-2"></i>
      {{ $t('dashboard.anniversaries') }}
    </h6>

    <div class="sidebar-jubilee-list">
      <div
          v-for="(user, index) of jubilees"
          :key="index"
          class="sidebar-jubilee-item">

        <div class="sidebar-jubilee-icon">
          <i class="fa-solid fa-star"></i>
        </div>

        <div class="sidebar-jubilee-data">
          <div class="sidebar-jubilee-user">
            <span class="user-name">{{ user?.firstName }} {{ user?.lastName }}</span>
            <span class="years-badge">{{ user?.years }} J.</span>
          </div>
          <span class="sidebar-jubilee-date">{{ user?.startingDate }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps} from 'vue'
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const companyColor = computed(() => companySettings.value?.colorCode || '#15803d');

const companyBgColor = computed(() => companySettings.value?.colorCode
    ? `${companySettings.value.colorCode}15`
    : '#ecfdf5'
)

defineProps({
  jubilees: {
    type: Array,
    required: true,
    default: () => []
  }
})
</script>

<style scoped>
.sidebar-section-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sidebar-jubilee-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 280px;
  overflow-y: auto;
  padding-right: 4px;
}

.sidebar-jubilee-list::-webkit-scrollbar {
  width: 4px;
}
.sidebar-jubilee-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.sidebar-jubilee-item {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 10px;
  transition: all 0.2s ease;
}

.sidebar-jubilee-item:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.sidebar-jubilee-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
  border-radius: 4px;
  font-size: 0.75rem;
  margin-right: 10px;
  flex-shrink: 0;
}

.sidebar-jubilee-data {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.sidebar-jubilee-user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.user-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.years-badge {
  font-size: 0.75rem;
  font-weight: 700;
  background-color: v-bind(companyBgColor);
  color: v-bind(companyColor);
  padding: 1px 6px;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}

.sidebar-jubilee-date {
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 1px;
}
</style>